module.exports = __webpack_public_path__ + "img/Dynamic_Pricing.9366b445.svg";